// GENERATED FILE — DO NOT EDIT. The forecast row's wire validators (F-30), one standalone
// function per schema of app/src/types/forecastWire.schema.generated.json (itself rendered from
// server/repo/forecastRow.js), emitted by ajv's standalone codegen in scripts/gen-forecast-wire.mjs;
// regenerate with `node scripts/gen-forecast-wire.mjs` (scripts/check.sh --step wire-types). Options:
// {"strict":false,"allErrors":true,"validateFormats":false,"allowUnionTypes":true} plus the codegen's own
// { code: { source: true, esm: true, lines: true } }. The module imports nothing and compiles
// nothing: app/src/lib/wireValidate.ts calls these as they are (no ajv in the bundle, nothing
// a CSP without 'unsafe-eval' refuses). Each export is `(data) => boolean` and leaves its `errors` on itself,
// ajv's ValidateFunction contract; see wireValidate.generated.d.ts for the types.
export const SCHEMA_NAMES = Object.freeze(["ForecastWire","SharedForecastWire","ScheduleSpec","NotifyPrefs","SeriesImpactPoint","SeriesImpacts","ListSummary","WireOwner","ForecastRowAny"]);
export const ForecastWire = validate47;
const schema33 = {"type":"object","properties":{"id":{"type":"string"},"forecastId":{"type":["string","null"]},"question":{"type":"string"},"contractQuestion":{"type":["string","null"]},"listSummary":{"anyOf":[{"$ref":"#/components/schemas/ListSummary"},{"type":"null"}]},"createdAt":{"type":"string"},"receivedAt":{"type":"string"},"contract":{},"events":{"type":"array"},"parentId":{"type":["string","null"]},"fork":{},"serverPrediction":{"type":["number","null"]},"serverExplanation":{"type":["string","null"]},"serverContext":{},"report":{},"resolution":{},"move":{},"seriesImpacts":{"$ref":"#/components/schemas/SeriesImpacts"},"contractKey":{"type":["string","null"]},"triggerOrigin":{},"isShared":{"type":"boolean"},"othersWatching":{"type":"boolean"},"status":{"type":"string"},"traceId":{"type":["string","null"]},"startedAt":{"type":["string","null"]},"lastStage":{"type":["string","null"]},"lastStep":{"type":["string","null"]},"lastProgress":{"type":["number","null"]},"lastMessage":{"type":["string","null"]},"_series":{},"schedule":{"anyOf":[{"$ref":"#/components/schemas/ScheduleSpec"},{"type":"null"}]},"notify":{"$ref":"#/components/schemas/NotifyPrefs"},"contractStatus":{"type":["string","null"]},"reportPointers":{"type":"array"},"history":{"type":"array"}},"required":["id"],"additionalProperties":false};
const schema34 = {"type":"object","properties":{"contract":{"type":"object"},"history":{"type":"array"}}};
const schema37 = {"type":"object","properties":{"type":{"type":"string"},"params":{"type":"object"}},"required":["type"]};
const schema38 = {"type":"object","properties":{"email":{"type":"boolean"},"thresholdPct":{"type":"number"},"leadingBin":{"type":"boolean"},"timezone":{"type":"string"}}};
const func1 = Object.prototype.hasOwnProperty;
const schema35 = {"type":"object","additionalProperties":{"type":"array","items":{"$ref":"#/components/schemas/SeriesImpactPoint"}}};
const schema36 = {"type":"object","properties":{"date":{"type":"string"},"delta_percent":{"type":"number"}}};

function validate23(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate23.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
let data0 = data[key0];
if(Array.isArray(data0)){
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
let data1 = data0[i0];
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.date !== undefined){
if(typeof data1.date !== "string"){
const err0 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1")+"/" + i0+"/date",schemaPath:"#/components/schemas/SeriesImpactPoint/properties/date/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data1.delta_percent !== undefined){
if(!(typeof data1.delta_percent == "number")){
const err1 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1")+"/" + i0+"/delta_percent",schemaPath:"#/components/schemas/SeriesImpactPoint/properties/delta_percent/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
else {
const err2 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1")+"/" + i0,schemaPath:"#/components/schemas/SeriesImpactPoint/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),schemaPath:"#/additionalProperties/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate23.errors = vErrors;
return errors === 0;
}
validate23.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate47(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate47.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema33.properties, key0))){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.id !== undefined){
if(typeof data.id !== "string"){
const err2 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.forecastId !== undefined){
let data1 = data.forecastId;
if((typeof data1 !== "string") && (data1 !== null)){
const err3 = {instancePath:instancePath+"/forecastId",schemaPath:"#/properties/forecastId/type",keyword:"type",params:{type: schema33.properties.forecastId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.question !== undefined){
if(typeof data.question !== "string"){
const err4 = {instancePath:instancePath+"/question",schemaPath:"#/properties/question/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.contractQuestion !== undefined){
let data3 = data.contractQuestion;
if((typeof data3 !== "string") && (data3 !== null)){
const err5 = {instancePath:instancePath+"/contractQuestion",schemaPath:"#/properties/contractQuestion/type",keyword:"type",params:{type: schema33.properties.contractQuestion.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.listSummary !== undefined){
let data4 = data.listSummary;
const _errs11 = errors;
let valid1 = false;
const _errs12 = errors;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.contract !== undefined){
let data5 = data4.contract;
if(!(data5 && typeof data5 == "object" && !Array.isArray(data5))){
const err6 = {instancePath:instancePath+"/listSummary/contract",schemaPath:"#/components/schemas/ListSummary/properties/contract/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data4.history !== undefined){
if(!(Array.isArray(data4.history))){
const err7 = {instancePath:instancePath+"/listSummary/history",schemaPath:"#/components/schemas/ListSummary/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath:instancePath+"/listSummary",schemaPath:"#/components/schemas/ListSummary/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
var _valid0 = _errs12 === errors;
valid1 = valid1 || _valid0;
if(_valid0){
var props0 = {};
props0.contract = true;
props0.history = true;
}
const _errs19 = errors;
if(data4 !== null){
const err9 = {instancePath:instancePath+"/listSummary",schemaPath:"#/properties/listSummary/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
var _valid0 = _errs19 === errors;
valid1 = valid1 || _valid0;
if(!valid1){
const err10 = {instancePath:instancePath+"/listSummary",schemaPath:"#/properties/listSummary/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
else {
errors = _errs11;
if(vErrors !== null){
if(_errs11){
vErrors.length = _errs11;
}
else {
vErrors = null;
}
}
}
}
if(data.createdAt !== undefined){
if(typeof data.createdAt !== "string"){
const err11 = {instancePath:instancePath+"/createdAt",schemaPath:"#/properties/createdAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.receivedAt !== undefined){
if(typeof data.receivedAt !== "string"){
const err12 = {instancePath:instancePath+"/receivedAt",schemaPath:"#/properties/receivedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.events !== undefined){
if(!(Array.isArray(data.events))){
const err13 = {instancePath:instancePath+"/events",schemaPath:"#/properties/events/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.parentId !== undefined){
let data10 = data.parentId;
if((typeof data10 !== "string") && (data10 !== null)){
const err14 = {instancePath:instancePath+"/parentId",schemaPath:"#/properties/parentId/type",keyword:"type",params:{type: schema33.properties.parentId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.serverPrediction !== undefined){
let data11 = data.serverPrediction;
if((!(typeof data11 == "number")) && (data11 !== null)){
const err15 = {instancePath:instancePath+"/serverPrediction",schemaPath:"#/properties/serverPrediction/type",keyword:"type",params:{type: schema33.properties.serverPrediction.type},message:"must be number,null"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.serverExplanation !== undefined){
let data12 = data.serverExplanation;
if((typeof data12 !== "string") && (data12 !== null)){
const err16 = {instancePath:instancePath+"/serverExplanation",schemaPath:"#/properties/serverExplanation/type",keyword:"type",params:{type: schema33.properties.serverExplanation.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.seriesImpacts !== undefined){
if(!(validate23(data.seriesImpacts, {instancePath:instancePath+"/seriesImpacts",parentData:data,parentDataProperty:"seriesImpacts",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
errors = vErrors.length;
}
}
if(data.contractKey !== undefined){
let data14 = data.contractKey;
if((typeof data14 !== "string") && (data14 !== null)){
const err17 = {instancePath:instancePath+"/contractKey",schemaPath:"#/properties/contractKey/type",keyword:"type",params:{type: schema33.properties.contractKey.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.isShared !== undefined){
if(typeof data.isShared !== "boolean"){
const err18 = {instancePath:instancePath+"/isShared",schemaPath:"#/properties/isShared/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.othersWatching !== undefined){
if(typeof data.othersWatching !== "boolean"){
const err19 = {instancePath:instancePath+"/othersWatching",schemaPath:"#/properties/othersWatching/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.status !== undefined){
if(typeof data.status !== "string"){
const err20 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.traceId !== undefined){
let data18 = data.traceId;
if((typeof data18 !== "string") && (data18 !== null)){
const err21 = {instancePath:instancePath+"/traceId",schemaPath:"#/properties/traceId/type",keyword:"type",params:{type: schema33.properties.traceId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.startedAt !== undefined){
let data19 = data.startedAt;
if((typeof data19 !== "string") && (data19 !== null)){
const err22 = {instancePath:instancePath+"/startedAt",schemaPath:"#/properties/startedAt/type",keyword:"type",params:{type: schema33.properties.startedAt.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.lastStage !== undefined){
let data20 = data.lastStage;
if((typeof data20 !== "string") && (data20 !== null)){
const err23 = {instancePath:instancePath+"/lastStage",schemaPath:"#/properties/lastStage/type",keyword:"type",params:{type: schema33.properties.lastStage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.lastStep !== undefined){
let data21 = data.lastStep;
if((typeof data21 !== "string") && (data21 !== null)){
const err24 = {instancePath:instancePath+"/lastStep",schemaPath:"#/properties/lastStep/type",keyword:"type",params:{type: schema33.properties.lastStep.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.lastProgress !== undefined){
let data22 = data.lastProgress;
if((!(typeof data22 == "number")) && (data22 !== null)){
const err25 = {instancePath:instancePath+"/lastProgress",schemaPath:"#/properties/lastProgress/type",keyword:"type",params:{type: schema33.properties.lastProgress.type},message:"must be number,null"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.lastMessage !== undefined){
let data23 = data.lastMessage;
if((typeof data23 !== "string") && (data23 !== null)){
const err26 = {instancePath:instancePath+"/lastMessage",schemaPath:"#/properties/lastMessage/type",keyword:"type",params:{type: schema33.properties.lastMessage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.schedule !== undefined){
let data24 = data.schedule;
const _errs55 = errors;
let valid4 = false;
const _errs56 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.type === undefined){
const err27 = {instancePath:instancePath+"/schedule",schemaPath:"#/components/schemas/ScheduleSpec/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data24.type !== undefined){
if(typeof data24.type !== "string"){
const err28 = {instancePath:instancePath+"/schedule/type",schemaPath:"#/components/schemas/ScheduleSpec/properties/type/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data24.params !== undefined){
let data26 = data24.params;
if(!(data26 && typeof data26 == "object" && !Array.isArray(data26))){
const err29 = {instancePath:instancePath+"/schedule/params",schemaPath:"#/components/schemas/ScheduleSpec/properties/params/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath:instancePath+"/schedule",schemaPath:"#/components/schemas/ScheduleSpec/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid1 = _errs56 === errors;
valid4 = valid4 || _valid1;
if(_valid1){
var props1 = {};
props1.type = true;
props1.params = true;
}
const _errs63 = errors;
if(data24 !== null){
const err31 = {instancePath:instancePath+"/schedule",schemaPath:"#/properties/schedule/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
var _valid1 = _errs63 === errors;
valid4 = valid4 || _valid1;
if(!valid4){
const err32 = {instancePath:instancePath+"/schedule",schemaPath:"#/properties/schedule/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs55;
if(vErrors !== null){
if(_errs55){
vErrors.length = _errs55;
}
else {
vErrors = null;
}
}
}
}
if(data.notify !== undefined){
let data27 = data.notify;
if(data27 && typeof data27 == "object" && !Array.isArray(data27)){
if(data27.email !== undefined){
if(typeof data27.email !== "boolean"){
const err33 = {instancePath:instancePath+"/notify/email",schemaPath:"#/components/schemas/NotifyPrefs/properties/email/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data27.thresholdPct !== undefined){
if(!(typeof data27.thresholdPct == "number")){
const err34 = {instancePath:instancePath+"/notify/thresholdPct",schemaPath:"#/components/schemas/NotifyPrefs/properties/thresholdPct/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data27.leadingBin !== undefined){
if(typeof data27.leadingBin !== "boolean"){
const err35 = {instancePath:instancePath+"/notify/leadingBin",schemaPath:"#/components/schemas/NotifyPrefs/properties/leadingBin/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data27.timezone !== undefined){
if(typeof data27.timezone !== "string"){
const err36 = {instancePath:instancePath+"/notify/timezone",schemaPath:"#/components/schemas/NotifyPrefs/properties/timezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath:instancePath+"/notify",schemaPath:"#/components/schemas/NotifyPrefs/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.contractStatus !== undefined){
let data32 = data.contractStatus;
if((typeof data32 !== "string") && (data32 !== null)){
const err38 = {instancePath:instancePath+"/contractStatus",schemaPath:"#/properties/contractStatus/type",keyword:"type",params:{type: schema33.properties.contractStatus.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.reportPointers !== undefined){
if(!(Array.isArray(data.reportPointers))){
const err39 = {instancePath:instancePath+"/reportPointers",schemaPath:"#/properties/reportPointers/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data.history !== undefined){
if(!(Array.isArray(data.history))){
const err40 = {instancePath:instancePath+"/history",schemaPath:"#/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
validate47.errors = vErrors;
return errors === 0;
}
validate47.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SharedForecastWire = validate49;
const schema40 = {"type":"object","properties":{"_series":{},"canEdit":{"type":"boolean"},"contract":{},"contractKey":{"type":["string","null"]},"contractQuestion":{"type":["string","null"]},"contractStatus":{"type":["string","null"]},"createdAt":{"type":"string"},"events":{"type":"array"},"forecastId":{"type":["string","null"]},"fork":{},"history":{"type":"array"},"id":{"type":"string"},"isOwn":{"const":false},"lastMessage":{"type":["string","null"]},"lastProgress":{"type":["number","null"]},"lastStage":{"type":["string","null"]},"lastStep":{"type":["string","null"]},"listSummary":{"anyOf":[{"$ref":"#/components/schemas/ListSummary"},{"type":"null"}]},"move":{},"notify":{"$ref":"#/components/schemas/NotifyPrefs"},"owner":{"$ref":"#/components/schemas/WireOwner"},"parentId":{"type":["string","null"]},"question":{"type":"string"},"receivedAt":{"type":"string"},"report":{},"reportPointers":{"type":"array"},"resolution":{},"schedule":{"anyOf":[{"$ref":"#/components/schemas/ScheduleSpec"},{"type":"null"}]},"seriesImpacts":{"$ref":"#/components/schemas/SeriesImpacts"},"serverContext":{},"serverExplanation":{"type":["string","null"]},"serverPrediction":{"type":["number","null"]},"startedAt":{"type":["string","null"]},"status":{"type":"string"},"traceId":{"type":["string","null"]},"triggerOrigin":{}},"required":["id","isOwn","owner"],"additionalProperties":false};
const schema43 = {"type":"object","properties":{"name":{"type":["string","null"]},"email":{"type":["string","null"]}},"required":["name","email"]};

function validate49(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate49.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.isOwn === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "isOwn"},message:"must have required property '"+"isOwn"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.owner === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "owner"},message:"must have required property '"+"owner"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema40.properties, key0))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.canEdit !== undefined){
if(typeof data.canEdit !== "boolean"){
const err4 = {instancePath:instancePath+"/canEdit",schemaPath:"#/properties/canEdit/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.contractKey !== undefined){
let data1 = data.contractKey;
if((typeof data1 !== "string") && (data1 !== null)){
const err5 = {instancePath:instancePath+"/contractKey",schemaPath:"#/properties/contractKey/type",keyword:"type",params:{type: schema40.properties.contractKey.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.contractQuestion !== undefined){
let data2 = data.contractQuestion;
if((typeof data2 !== "string") && (data2 !== null)){
const err6 = {instancePath:instancePath+"/contractQuestion",schemaPath:"#/properties/contractQuestion/type",keyword:"type",params:{type: schema40.properties.contractQuestion.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.contractStatus !== undefined){
let data3 = data.contractStatus;
if((typeof data3 !== "string") && (data3 !== null)){
const err7 = {instancePath:instancePath+"/contractStatus",schemaPath:"#/properties/contractStatus/type",keyword:"type",params:{type: schema40.properties.contractStatus.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.createdAt !== undefined){
if(typeof data.createdAt !== "string"){
const err8 = {instancePath:instancePath+"/createdAt",schemaPath:"#/properties/createdAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.events !== undefined){
if(!(Array.isArray(data.events))){
const err9 = {instancePath:instancePath+"/events",schemaPath:"#/properties/events/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.forecastId !== undefined){
let data6 = data.forecastId;
if((typeof data6 !== "string") && (data6 !== null)){
const err10 = {instancePath:instancePath+"/forecastId",schemaPath:"#/properties/forecastId/type",keyword:"type",params:{type: schema40.properties.forecastId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.history !== undefined){
if(!(Array.isArray(data.history))){
const err11 = {instancePath:instancePath+"/history",schemaPath:"#/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.id !== undefined){
if(typeof data.id !== "string"){
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.isOwn !== undefined){
if(false !== data.isOwn){
const err13 = {instancePath:instancePath+"/isOwn",schemaPath:"#/properties/isOwn/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.lastMessage !== undefined){
let data10 = data.lastMessage;
if((typeof data10 !== "string") && (data10 !== null)){
const err14 = {instancePath:instancePath+"/lastMessage",schemaPath:"#/properties/lastMessage/type",keyword:"type",params:{type: schema40.properties.lastMessage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.lastProgress !== undefined){
let data11 = data.lastProgress;
if((!(typeof data11 == "number")) && (data11 !== null)){
const err15 = {instancePath:instancePath+"/lastProgress",schemaPath:"#/properties/lastProgress/type",keyword:"type",params:{type: schema40.properties.lastProgress.type},message:"must be number,null"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.lastStage !== undefined){
let data12 = data.lastStage;
if((typeof data12 !== "string") && (data12 !== null)){
const err16 = {instancePath:instancePath+"/lastStage",schemaPath:"#/properties/lastStage/type",keyword:"type",params:{type: schema40.properties.lastStage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.lastStep !== undefined){
let data13 = data.lastStep;
if((typeof data13 !== "string") && (data13 !== null)){
const err17 = {instancePath:instancePath+"/lastStep",schemaPath:"#/properties/lastStep/type",keyword:"type",params:{type: schema40.properties.lastStep.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.listSummary !== undefined){
let data14 = data.listSummary;
const _errs30 = errors;
let valid1 = false;
const _errs31 = errors;
if(data14 && typeof data14 == "object" && !Array.isArray(data14)){
if(data14.contract !== undefined){
let data15 = data14.contract;
if(!(data15 && typeof data15 == "object" && !Array.isArray(data15))){
const err18 = {instancePath:instancePath+"/listSummary/contract",schemaPath:"#/components/schemas/ListSummary/properties/contract/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data14.history !== undefined){
if(!(Array.isArray(data14.history))){
const err19 = {instancePath:instancePath+"/listSummary/history",schemaPath:"#/components/schemas/ListSummary/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath:instancePath+"/listSummary",schemaPath:"#/components/schemas/ListSummary/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
var _valid0 = _errs31 === errors;
valid1 = valid1 || _valid0;
if(_valid0){
var props0 = {};
props0.contract = true;
props0.history = true;
}
const _errs38 = errors;
if(data14 !== null){
const err21 = {instancePath:instancePath+"/listSummary",schemaPath:"#/properties/listSummary/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
var _valid0 = _errs38 === errors;
valid1 = valid1 || _valid0;
if(!valid1){
const err22 = {instancePath:instancePath+"/listSummary",schemaPath:"#/properties/listSummary/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
else {
errors = _errs30;
if(vErrors !== null){
if(_errs30){
vErrors.length = _errs30;
}
else {
vErrors = null;
}
}
}
}
if(data.notify !== undefined){
let data17 = data.notify;
if(data17 && typeof data17 == "object" && !Array.isArray(data17)){
if(data17.email !== undefined){
if(typeof data17.email !== "boolean"){
const err23 = {instancePath:instancePath+"/notify/email",schemaPath:"#/components/schemas/NotifyPrefs/properties/email/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data17.thresholdPct !== undefined){
if(!(typeof data17.thresholdPct == "number")){
const err24 = {instancePath:instancePath+"/notify/thresholdPct",schemaPath:"#/components/schemas/NotifyPrefs/properties/thresholdPct/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data17.leadingBin !== undefined){
if(typeof data17.leadingBin !== "boolean"){
const err25 = {instancePath:instancePath+"/notify/leadingBin",schemaPath:"#/components/schemas/NotifyPrefs/properties/leadingBin/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data17.timezone !== undefined){
if(typeof data17.timezone !== "string"){
const err26 = {instancePath:instancePath+"/notify/timezone",schemaPath:"#/components/schemas/NotifyPrefs/properties/timezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath:instancePath+"/notify",schemaPath:"#/components/schemas/NotifyPrefs/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.owner !== undefined){
let data22 = data.owner;
if(data22 && typeof data22 == "object" && !Array.isArray(data22)){
if(data22.name === undefined){
const err28 = {instancePath:instancePath+"/owner",schemaPath:"#/components/schemas/WireOwner/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data22.email === undefined){
const err29 = {instancePath:instancePath+"/owner",schemaPath:"#/components/schemas/WireOwner/required",keyword:"required",params:{missingProperty: "email"},message:"must have required property '"+"email"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data22.name !== undefined){
let data23 = data22.name;
if((typeof data23 !== "string") && (data23 !== null)){
const err30 = {instancePath:instancePath+"/owner/name",schemaPath:"#/components/schemas/WireOwner/properties/name/type",keyword:"type",params:{type: schema43.properties.name.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data22.email !== undefined){
let data24 = data22.email;
if((typeof data24 !== "string") && (data24 !== null)){
const err31 = {instancePath:instancePath+"/owner/email",schemaPath:"#/components/schemas/WireOwner/properties/email/type",keyword:"type",params:{type: schema43.properties.email.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
else {
const err32 = {instancePath:instancePath+"/owner",schemaPath:"#/components/schemas/WireOwner/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.parentId !== undefined){
let data25 = data.parentId;
if((typeof data25 !== "string") && (data25 !== null)){
const err33 = {instancePath:instancePath+"/parentId",schemaPath:"#/properties/parentId/type",keyword:"type",params:{type: schema40.properties.parentId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.question !== undefined){
if(typeof data.question !== "string"){
const err34 = {instancePath:instancePath+"/question",schemaPath:"#/properties/question/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data.receivedAt !== undefined){
if(typeof data.receivedAt !== "string"){
const err35 = {instancePath:instancePath+"/receivedAt",schemaPath:"#/properties/receivedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.reportPointers !== undefined){
if(!(Array.isArray(data.reportPointers))){
const err36 = {instancePath:instancePath+"/reportPointers",schemaPath:"#/properties/reportPointers/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data.schedule !== undefined){
let data29 = data.schedule;
const _errs67 = errors;
let valid8 = false;
const _errs68 = errors;
if(data29 && typeof data29 == "object" && !Array.isArray(data29)){
if(data29.type === undefined){
const err37 = {instancePath:instancePath+"/schedule",schemaPath:"#/components/schemas/ScheduleSpec/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data29.type !== undefined){
if(typeof data29.type !== "string"){
const err38 = {instancePath:instancePath+"/schedule/type",schemaPath:"#/components/schemas/ScheduleSpec/properties/type/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data29.params !== undefined){
let data31 = data29.params;
if(!(data31 && typeof data31 == "object" && !Array.isArray(data31))){
const err39 = {instancePath:instancePath+"/schedule/params",schemaPath:"#/components/schemas/ScheduleSpec/properties/params/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
else {
const err40 = {instancePath:instancePath+"/schedule",schemaPath:"#/components/schemas/ScheduleSpec/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
var _valid1 = _errs68 === errors;
valid8 = valid8 || _valid1;
if(_valid1){
var props1 = {};
props1.type = true;
props1.params = true;
}
const _errs75 = errors;
if(data29 !== null){
const err41 = {instancePath:instancePath+"/schedule",schemaPath:"#/properties/schedule/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
var _valid1 = _errs75 === errors;
valid8 = valid8 || _valid1;
if(!valid8){
const err42 = {instancePath:instancePath+"/schedule",schemaPath:"#/properties/schedule/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
else {
errors = _errs67;
if(vErrors !== null){
if(_errs67){
vErrors.length = _errs67;
}
else {
vErrors = null;
}
}
}
}
if(data.seriesImpacts !== undefined){
if(!(validate23(data.seriesImpacts, {instancePath:instancePath+"/seriesImpacts",parentData:data,parentDataProperty:"seriesImpacts",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
errors = vErrors.length;
}
}
if(data.serverExplanation !== undefined){
let data33 = data.serverExplanation;
if((typeof data33 !== "string") && (data33 !== null)){
const err43 = {instancePath:instancePath+"/serverExplanation",schemaPath:"#/properties/serverExplanation/type",keyword:"type",params:{type: schema40.properties.serverExplanation.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.serverPrediction !== undefined){
let data34 = data.serverPrediction;
if((!(typeof data34 == "number")) && (data34 !== null)){
const err44 = {instancePath:instancePath+"/serverPrediction",schemaPath:"#/properties/serverPrediction/type",keyword:"type",params:{type: schema40.properties.serverPrediction.type},message:"must be number,null"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data.startedAt !== undefined){
let data35 = data.startedAt;
if((typeof data35 !== "string") && (data35 !== null)){
const err45 = {instancePath:instancePath+"/startedAt",schemaPath:"#/properties/startedAt/type",keyword:"type",params:{type: schema40.properties.startedAt.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data.status !== undefined){
if(typeof data.status !== "string"){
const err46 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data.traceId !== undefined){
let data37 = data.traceId;
if((typeof data37 !== "string") && (data37 !== null)){
const err47 = {instancePath:instancePath+"/traceId",schemaPath:"#/properties/traceId/type",keyword:"type",params:{type: schema40.properties.traceId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
}
else {
const err48 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
validate49.errors = vErrors;
return errors === 0;
}
validate49.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const ScheduleSpec = validate51;

function validate51(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate51.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.type === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.type !== undefined){
if(typeof data.type !== "string"){
const err1 = {instancePath:instancePath+"/type",schemaPath:"#/properties/type/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.params !== undefined){
let data1 = data.params;
if(!(data1 && typeof data1 == "object" && !Array.isArray(data1))){
const err2 = {instancePath:instancePath+"/params",schemaPath:"#/properties/params/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
validate51.errors = vErrors;
return errors === 0;
}
validate51.evaluated = {"props":{"type":true,"params":true},"dynamicProps":false,"dynamicItems":false};

export const NotifyPrefs = validate52;

function validate52(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate52.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.email !== undefined){
if(typeof data.email !== "boolean"){
const err0 = {instancePath:instancePath+"/email",schemaPath:"#/properties/email/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data.thresholdPct !== undefined){
if(!(typeof data.thresholdPct == "number")){
const err1 = {instancePath:instancePath+"/thresholdPct",schemaPath:"#/properties/thresholdPct/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.leadingBin !== undefined){
if(typeof data.leadingBin !== "boolean"){
const err2 = {instancePath:instancePath+"/leadingBin",schemaPath:"#/properties/leadingBin/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.timezone !== undefined){
if(typeof data.timezone !== "string"){
const err3 = {instancePath:instancePath+"/timezone",schemaPath:"#/properties/timezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate52.errors = vErrors;
return errors === 0;
}
validate52.evaluated = {"props":{"email":true,"thresholdPct":true,"leadingBin":true,"timezone":true},"dynamicProps":false,"dynamicItems":false};

export const SeriesImpactPoint = validate53;

function validate53(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate53.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.date !== undefined){
if(typeof data.date !== "string"){
const err0 = {instancePath:instancePath+"/date",schemaPath:"#/properties/date/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data.delta_percent !== undefined){
if(!(typeof data.delta_percent == "number")){
const err1 = {instancePath:instancePath+"/delta_percent",schemaPath:"#/properties/delta_percent/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
else {
const err2 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
validate53.errors = vErrors;
return errors === 0;
}
validate53.evaluated = {"props":{"date":true,"delta_percent":true},"dynamicProps":false,"dynamicItems":false};

export const SeriesImpacts = validate54;

function validate54(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate54.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
let data0 = data[key0];
if(Array.isArray(data0)){
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
let data1 = data0[i0];
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.date !== undefined){
if(typeof data1.date !== "string"){
const err0 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1")+"/" + i0+"/date",schemaPath:"#/components/schemas/SeriesImpactPoint/properties/date/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data1.delta_percent !== undefined){
if(!(typeof data1.delta_percent == "number")){
const err1 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1")+"/" + i0+"/delta_percent",schemaPath:"#/components/schemas/SeriesImpactPoint/properties/delta_percent/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
else {
const err2 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1")+"/" + i0,schemaPath:"#/components/schemas/SeriesImpactPoint/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),schemaPath:"#/additionalProperties/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate54.errors = vErrors;
return errors === 0;
}
validate54.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const ListSummary = validate55;

function validate55(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate55.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.contract !== undefined){
let data0 = data.contract;
if(!(data0 && typeof data0 == "object" && !Array.isArray(data0))){
const err0 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data.history !== undefined){
if(!(Array.isArray(data.history))){
const err1 = {instancePath:instancePath+"/history",schemaPath:"#/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
else {
const err2 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
validate55.errors = vErrors;
return errors === 0;
}
validate55.evaluated = {"props":{"contract":true,"history":true},"dynamicProps":false,"dynamicItems":false};

export const WireOwner = validate56;

function validate56(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate56.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.email === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "email"},message:"must have required property '"+"email"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.name !== undefined){
let data0 = data.name;
if((typeof data0 !== "string") && (data0 !== null)){
const err2 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: schema43.properties.name.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.email !== undefined){
let data1 = data.email;
if((typeof data1 !== "string") && (data1 !== null)){
const err3 = {instancePath:instancePath+"/email",schemaPath:"#/properties/email/type",keyword:"type",params:{type: schema43.properties.email.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate56.errors = vErrors;
return errors === 0;
}
validate56.evaluated = {"props":{"name":true,"email":true},"dynamicProps":false,"dynamicItems":false};

export const ForecastRowAny = validate57;
const schema59 = {"anyOf":[{"$ref":"#/components/schemas/ForecastWire"},{"$ref":"#/components/schemas/SharedForecastWire"}]};

function validate40(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate40.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema33.properties, key0))){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.id !== undefined){
if(typeof data.id !== "string"){
const err2 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.forecastId !== undefined){
let data1 = data.forecastId;
if((typeof data1 !== "string") && (data1 !== null)){
const err3 = {instancePath:instancePath+"/forecastId",schemaPath:"#/properties/forecastId/type",keyword:"type",params:{type: schema33.properties.forecastId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.question !== undefined){
if(typeof data.question !== "string"){
const err4 = {instancePath:instancePath+"/question",schemaPath:"#/properties/question/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.contractQuestion !== undefined){
let data3 = data.contractQuestion;
if((typeof data3 !== "string") && (data3 !== null)){
const err5 = {instancePath:instancePath+"/contractQuestion",schemaPath:"#/properties/contractQuestion/type",keyword:"type",params:{type: schema33.properties.contractQuestion.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.listSummary !== undefined){
let data4 = data.listSummary;
const _errs11 = errors;
let valid1 = false;
const _errs12 = errors;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.contract !== undefined){
let data5 = data4.contract;
if(!(data5 && typeof data5 == "object" && !Array.isArray(data5))){
const err6 = {instancePath:instancePath+"/listSummary/contract",schemaPath:"#/components/schemas/ListSummary/properties/contract/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data4.history !== undefined){
if(!(Array.isArray(data4.history))){
const err7 = {instancePath:instancePath+"/listSummary/history",schemaPath:"#/components/schemas/ListSummary/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath:instancePath+"/listSummary",schemaPath:"#/components/schemas/ListSummary/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
var _valid0 = _errs12 === errors;
valid1 = valid1 || _valid0;
if(_valid0){
var props0 = {};
props0.contract = true;
props0.history = true;
}
const _errs19 = errors;
if(data4 !== null){
const err9 = {instancePath:instancePath+"/listSummary",schemaPath:"#/properties/listSummary/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
var _valid0 = _errs19 === errors;
valid1 = valid1 || _valid0;
if(!valid1){
const err10 = {instancePath:instancePath+"/listSummary",schemaPath:"#/properties/listSummary/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
else {
errors = _errs11;
if(vErrors !== null){
if(_errs11){
vErrors.length = _errs11;
}
else {
vErrors = null;
}
}
}
}
if(data.createdAt !== undefined){
if(typeof data.createdAt !== "string"){
const err11 = {instancePath:instancePath+"/createdAt",schemaPath:"#/properties/createdAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.receivedAt !== undefined){
if(typeof data.receivedAt !== "string"){
const err12 = {instancePath:instancePath+"/receivedAt",schemaPath:"#/properties/receivedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.events !== undefined){
if(!(Array.isArray(data.events))){
const err13 = {instancePath:instancePath+"/events",schemaPath:"#/properties/events/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.parentId !== undefined){
let data10 = data.parentId;
if((typeof data10 !== "string") && (data10 !== null)){
const err14 = {instancePath:instancePath+"/parentId",schemaPath:"#/properties/parentId/type",keyword:"type",params:{type: schema33.properties.parentId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.serverPrediction !== undefined){
let data11 = data.serverPrediction;
if((!(typeof data11 == "number")) && (data11 !== null)){
const err15 = {instancePath:instancePath+"/serverPrediction",schemaPath:"#/properties/serverPrediction/type",keyword:"type",params:{type: schema33.properties.serverPrediction.type},message:"must be number,null"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.serverExplanation !== undefined){
let data12 = data.serverExplanation;
if((typeof data12 !== "string") && (data12 !== null)){
const err16 = {instancePath:instancePath+"/serverExplanation",schemaPath:"#/properties/serverExplanation/type",keyword:"type",params:{type: schema33.properties.serverExplanation.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.seriesImpacts !== undefined){
if(!(validate23(data.seriesImpacts, {instancePath:instancePath+"/seriesImpacts",parentData:data,parentDataProperty:"seriesImpacts",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
errors = vErrors.length;
}
}
if(data.contractKey !== undefined){
let data14 = data.contractKey;
if((typeof data14 !== "string") && (data14 !== null)){
const err17 = {instancePath:instancePath+"/contractKey",schemaPath:"#/properties/contractKey/type",keyword:"type",params:{type: schema33.properties.contractKey.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.isShared !== undefined){
if(typeof data.isShared !== "boolean"){
const err18 = {instancePath:instancePath+"/isShared",schemaPath:"#/properties/isShared/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.othersWatching !== undefined){
if(typeof data.othersWatching !== "boolean"){
const err19 = {instancePath:instancePath+"/othersWatching",schemaPath:"#/properties/othersWatching/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.status !== undefined){
if(typeof data.status !== "string"){
const err20 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.traceId !== undefined){
let data18 = data.traceId;
if((typeof data18 !== "string") && (data18 !== null)){
const err21 = {instancePath:instancePath+"/traceId",schemaPath:"#/properties/traceId/type",keyword:"type",params:{type: schema33.properties.traceId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.startedAt !== undefined){
let data19 = data.startedAt;
if((typeof data19 !== "string") && (data19 !== null)){
const err22 = {instancePath:instancePath+"/startedAt",schemaPath:"#/properties/startedAt/type",keyword:"type",params:{type: schema33.properties.startedAt.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.lastStage !== undefined){
let data20 = data.lastStage;
if((typeof data20 !== "string") && (data20 !== null)){
const err23 = {instancePath:instancePath+"/lastStage",schemaPath:"#/properties/lastStage/type",keyword:"type",params:{type: schema33.properties.lastStage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.lastStep !== undefined){
let data21 = data.lastStep;
if((typeof data21 !== "string") && (data21 !== null)){
const err24 = {instancePath:instancePath+"/lastStep",schemaPath:"#/properties/lastStep/type",keyword:"type",params:{type: schema33.properties.lastStep.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.lastProgress !== undefined){
let data22 = data.lastProgress;
if((!(typeof data22 == "number")) && (data22 !== null)){
const err25 = {instancePath:instancePath+"/lastProgress",schemaPath:"#/properties/lastProgress/type",keyword:"type",params:{type: schema33.properties.lastProgress.type},message:"must be number,null"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.lastMessage !== undefined){
let data23 = data.lastMessage;
if((typeof data23 !== "string") && (data23 !== null)){
const err26 = {instancePath:instancePath+"/lastMessage",schemaPath:"#/properties/lastMessage/type",keyword:"type",params:{type: schema33.properties.lastMessage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.schedule !== undefined){
let data24 = data.schedule;
const _errs55 = errors;
let valid4 = false;
const _errs56 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.type === undefined){
const err27 = {instancePath:instancePath+"/schedule",schemaPath:"#/components/schemas/ScheduleSpec/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data24.type !== undefined){
if(typeof data24.type !== "string"){
const err28 = {instancePath:instancePath+"/schedule/type",schemaPath:"#/components/schemas/ScheduleSpec/properties/type/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data24.params !== undefined){
let data26 = data24.params;
if(!(data26 && typeof data26 == "object" && !Array.isArray(data26))){
const err29 = {instancePath:instancePath+"/schedule/params",schemaPath:"#/components/schemas/ScheduleSpec/properties/params/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath:instancePath+"/schedule",schemaPath:"#/components/schemas/ScheduleSpec/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid1 = _errs56 === errors;
valid4 = valid4 || _valid1;
if(_valid1){
var props1 = {};
props1.type = true;
props1.params = true;
}
const _errs63 = errors;
if(data24 !== null){
const err31 = {instancePath:instancePath+"/schedule",schemaPath:"#/properties/schedule/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
var _valid1 = _errs63 === errors;
valid4 = valid4 || _valid1;
if(!valid4){
const err32 = {instancePath:instancePath+"/schedule",schemaPath:"#/properties/schedule/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs55;
if(vErrors !== null){
if(_errs55){
vErrors.length = _errs55;
}
else {
vErrors = null;
}
}
}
}
if(data.notify !== undefined){
let data27 = data.notify;
if(data27 && typeof data27 == "object" && !Array.isArray(data27)){
if(data27.email !== undefined){
if(typeof data27.email !== "boolean"){
const err33 = {instancePath:instancePath+"/notify/email",schemaPath:"#/components/schemas/NotifyPrefs/properties/email/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data27.thresholdPct !== undefined){
if(!(typeof data27.thresholdPct == "number")){
const err34 = {instancePath:instancePath+"/notify/thresholdPct",schemaPath:"#/components/schemas/NotifyPrefs/properties/thresholdPct/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data27.leadingBin !== undefined){
if(typeof data27.leadingBin !== "boolean"){
const err35 = {instancePath:instancePath+"/notify/leadingBin",schemaPath:"#/components/schemas/NotifyPrefs/properties/leadingBin/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data27.timezone !== undefined){
if(typeof data27.timezone !== "string"){
const err36 = {instancePath:instancePath+"/notify/timezone",schemaPath:"#/components/schemas/NotifyPrefs/properties/timezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath:instancePath+"/notify",schemaPath:"#/components/schemas/NotifyPrefs/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.contractStatus !== undefined){
let data32 = data.contractStatus;
if((typeof data32 !== "string") && (data32 !== null)){
const err38 = {instancePath:instancePath+"/contractStatus",schemaPath:"#/properties/contractStatus/type",keyword:"type",params:{type: schema33.properties.contractStatus.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.reportPointers !== undefined){
if(!(Array.isArray(data.reportPointers))){
const err39 = {instancePath:instancePath+"/reportPointers",schemaPath:"#/properties/reportPointers/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data.history !== undefined){
if(!(Array.isArray(data.history))){
const err40 = {instancePath:instancePath+"/history",schemaPath:"#/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
validate40.errors = vErrors;
return errors === 0;
}
validate40.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate43(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate43.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.isOwn === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "isOwn"},message:"must have required property '"+"isOwn"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.owner === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "owner"},message:"must have required property '"+"owner"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema40.properties, key0))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.canEdit !== undefined){
if(typeof data.canEdit !== "boolean"){
const err4 = {instancePath:instancePath+"/canEdit",schemaPath:"#/properties/canEdit/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.contractKey !== undefined){
let data1 = data.contractKey;
if((typeof data1 !== "string") && (data1 !== null)){
const err5 = {instancePath:instancePath+"/contractKey",schemaPath:"#/properties/contractKey/type",keyword:"type",params:{type: schema40.properties.contractKey.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.contractQuestion !== undefined){
let data2 = data.contractQuestion;
if((typeof data2 !== "string") && (data2 !== null)){
const err6 = {instancePath:instancePath+"/contractQuestion",schemaPath:"#/properties/contractQuestion/type",keyword:"type",params:{type: schema40.properties.contractQuestion.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.contractStatus !== undefined){
let data3 = data.contractStatus;
if((typeof data3 !== "string") && (data3 !== null)){
const err7 = {instancePath:instancePath+"/contractStatus",schemaPath:"#/properties/contractStatus/type",keyword:"type",params:{type: schema40.properties.contractStatus.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.createdAt !== undefined){
if(typeof data.createdAt !== "string"){
const err8 = {instancePath:instancePath+"/createdAt",schemaPath:"#/properties/createdAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.events !== undefined){
if(!(Array.isArray(data.events))){
const err9 = {instancePath:instancePath+"/events",schemaPath:"#/properties/events/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.forecastId !== undefined){
let data6 = data.forecastId;
if((typeof data6 !== "string") && (data6 !== null)){
const err10 = {instancePath:instancePath+"/forecastId",schemaPath:"#/properties/forecastId/type",keyword:"type",params:{type: schema40.properties.forecastId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.history !== undefined){
if(!(Array.isArray(data.history))){
const err11 = {instancePath:instancePath+"/history",schemaPath:"#/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.id !== undefined){
if(typeof data.id !== "string"){
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.isOwn !== undefined){
if(false !== data.isOwn){
const err13 = {instancePath:instancePath+"/isOwn",schemaPath:"#/properties/isOwn/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.lastMessage !== undefined){
let data10 = data.lastMessage;
if((typeof data10 !== "string") && (data10 !== null)){
const err14 = {instancePath:instancePath+"/lastMessage",schemaPath:"#/properties/lastMessage/type",keyword:"type",params:{type: schema40.properties.lastMessage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.lastProgress !== undefined){
let data11 = data.lastProgress;
if((!(typeof data11 == "number")) && (data11 !== null)){
const err15 = {instancePath:instancePath+"/lastProgress",schemaPath:"#/properties/lastProgress/type",keyword:"type",params:{type: schema40.properties.lastProgress.type},message:"must be number,null"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.lastStage !== undefined){
let data12 = data.lastStage;
if((typeof data12 !== "string") && (data12 !== null)){
const err16 = {instancePath:instancePath+"/lastStage",schemaPath:"#/properties/lastStage/type",keyword:"type",params:{type: schema40.properties.lastStage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.lastStep !== undefined){
let data13 = data.lastStep;
if((typeof data13 !== "string") && (data13 !== null)){
const err17 = {instancePath:instancePath+"/lastStep",schemaPath:"#/properties/lastStep/type",keyword:"type",params:{type: schema40.properties.lastStep.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.listSummary !== undefined){
let data14 = data.listSummary;
const _errs30 = errors;
let valid1 = false;
const _errs31 = errors;
if(data14 && typeof data14 == "object" && !Array.isArray(data14)){
if(data14.contract !== undefined){
let data15 = data14.contract;
if(!(data15 && typeof data15 == "object" && !Array.isArray(data15))){
const err18 = {instancePath:instancePath+"/listSummary/contract",schemaPath:"#/components/schemas/ListSummary/properties/contract/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data14.history !== undefined){
if(!(Array.isArray(data14.history))){
const err19 = {instancePath:instancePath+"/listSummary/history",schemaPath:"#/components/schemas/ListSummary/properties/history/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath:instancePath+"/listSummary",schemaPath:"#/components/schemas/ListSummary/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
var _valid0 = _errs31 === errors;
valid1 = valid1 || _valid0;
if(_valid0){
var props0 = {};
props0.contract = true;
props0.history = true;
}
const _errs38 = errors;
if(data14 !== null){
const err21 = {instancePath:instancePath+"/listSummary",schemaPath:"#/properties/listSummary/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
var _valid0 = _errs38 === errors;
valid1 = valid1 || _valid0;
if(!valid1){
const err22 = {instancePath:instancePath+"/listSummary",schemaPath:"#/properties/listSummary/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
else {
errors = _errs30;
if(vErrors !== null){
if(_errs30){
vErrors.length = _errs30;
}
else {
vErrors = null;
}
}
}
}
if(data.notify !== undefined){
let data17 = data.notify;
if(data17 && typeof data17 == "object" && !Array.isArray(data17)){
if(data17.email !== undefined){
if(typeof data17.email !== "boolean"){
const err23 = {instancePath:instancePath+"/notify/email",schemaPath:"#/components/schemas/NotifyPrefs/properties/email/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data17.thresholdPct !== undefined){
if(!(typeof data17.thresholdPct == "number")){
const err24 = {instancePath:instancePath+"/notify/thresholdPct",schemaPath:"#/components/schemas/NotifyPrefs/properties/thresholdPct/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data17.leadingBin !== undefined){
if(typeof data17.leadingBin !== "boolean"){
const err25 = {instancePath:instancePath+"/notify/leadingBin",schemaPath:"#/components/schemas/NotifyPrefs/properties/leadingBin/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data17.timezone !== undefined){
if(typeof data17.timezone !== "string"){
const err26 = {instancePath:instancePath+"/notify/timezone",schemaPath:"#/components/schemas/NotifyPrefs/properties/timezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath:instancePath+"/notify",schemaPath:"#/components/schemas/NotifyPrefs/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.owner !== undefined){
let data22 = data.owner;
if(data22 && typeof data22 == "object" && !Array.isArray(data22)){
if(data22.name === undefined){
const err28 = {instancePath:instancePath+"/owner",schemaPath:"#/components/schemas/WireOwner/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data22.email === undefined){
const err29 = {instancePath:instancePath+"/owner",schemaPath:"#/components/schemas/WireOwner/required",keyword:"required",params:{missingProperty: "email"},message:"must have required property '"+"email"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data22.name !== undefined){
let data23 = data22.name;
if((typeof data23 !== "string") && (data23 !== null)){
const err30 = {instancePath:instancePath+"/owner/name",schemaPath:"#/components/schemas/WireOwner/properties/name/type",keyword:"type",params:{type: schema43.properties.name.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data22.email !== undefined){
let data24 = data22.email;
if((typeof data24 !== "string") && (data24 !== null)){
const err31 = {instancePath:instancePath+"/owner/email",schemaPath:"#/components/schemas/WireOwner/properties/email/type",keyword:"type",params:{type: schema43.properties.email.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
else {
const err32 = {instancePath:instancePath+"/owner",schemaPath:"#/components/schemas/WireOwner/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.parentId !== undefined){
let data25 = data.parentId;
if((typeof data25 !== "string") && (data25 !== null)){
const err33 = {instancePath:instancePath+"/parentId",schemaPath:"#/properties/parentId/type",keyword:"type",params:{type: schema40.properties.parentId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.question !== undefined){
if(typeof data.question !== "string"){
const err34 = {instancePath:instancePath+"/question",schemaPath:"#/properties/question/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data.receivedAt !== undefined){
if(typeof data.receivedAt !== "string"){
const err35 = {instancePath:instancePath+"/receivedAt",schemaPath:"#/properties/receivedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.reportPointers !== undefined){
if(!(Array.isArray(data.reportPointers))){
const err36 = {instancePath:instancePath+"/reportPointers",schemaPath:"#/properties/reportPointers/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data.schedule !== undefined){
let data29 = data.schedule;
const _errs67 = errors;
let valid8 = false;
const _errs68 = errors;
if(data29 && typeof data29 == "object" && !Array.isArray(data29)){
if(data29.type === undefined){
const err37 = {instancePath:instancePath+"/schedule",schemaPath:"#/components/schemas/ScheduleSpec/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data29.type !== undefined){
if(typeof data29.type !== "string"){
const err38 = {instancePath:instancePath+"/schedule/type",schemaPath:"#/components/schemas/ScheduleSpec/properties/type/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data29.params !== undefined){
let data31 = data29.params;
if(!(data31 && typeof data31 == "object" && !Array.isArray(data31))){
const err39 = {instancePath:instancePath+"/schedule/params",schemaPath:"#/components/schemas/ScheduleSpec/properties/params/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
else {
const err40 = {instancePath:instancePath+"/schedule",schemaPath:"#/components/schemas/ScheduleSpec/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
var _valid1 = _errs68 === errors;
valid8 = valid8 || _valid1;
if(_valid1){
var props1 = {};
props1.type = true;
props1.params = true;
}
const _errs75 = errors;
if(data29 !== null){
const err41 = {instancePath:instancePath+"/schedule",schemaPath:"#/properties/schedule/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
var _valid1 = _errs75 === errors;
valid8 = valid8 || _valid1;
if(!valid8){
const err42 = {instancePath:instancePath+"/schedule",schemaPath:"#/properties/schedule/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
else {
errors = _errs67;
if(vErrors !== null){
if(_errs67){
vErrors.length = _errs67;
}
else {
vErrors = null;
}
}
}
}
if(data.seriesImpacts !== undefined){
if(!(validate23(data.seriesImpacts, {instancePath:instancePath+"/seriesImpacts",parentData:data,parentDataProperty:"seriesImpacts",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
errors = vErrors.length;
}
}
if(data.serverExplanation !== undefined){
let data33 = data.serverExplanation;
if((typeof data33 !== "string") && (data33 !== null)){
const err43 = {instancePath:instancePath+"/serverExplanation",schemaPath:"#/properties/serverExplanation/type",keyword:"type",params:{type: schema40.properties.serverExplanation.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.serverPrediction !== undefined){
let data34 = data.serverPrediction;
if((!(typeof data34 == "number")) && (data34 !== null)){
const err44 = {instancePath:instancePath+"/serverPrediction",schemaPath:"#/properties/serverPrediction/type",keyword:"type",params:{type: schema40.properties.serverPrediction.type},message:"must be number,null"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data.startedAt !== undefined){
let data35 = data.startedAt;
if((typeof data35 !== "string") && (data35 !== null)){
const err45 = {instancePath:instancePath+"/startedAt",schemaPath:"#/properties/startedAt/type",keyword:"type",params:{type: schema40.properties.startedAt.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data.status !== undefined){
if(typeof data.status !== "string"){
const err46 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data.traceId !== undefined){
let data37 = data.traceId;
if((typeof data37 !== "string") && (data37 !== null)){
const err47 = {instancePath:instancePath+"/traceId",schemaPath:"#/properties/traceId/type",keyword:"type",params:{type: schema40.properties.traceId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
}
else {
const err48 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
validate43.errors = vErrors;
return errors === 0;
}
validate43.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate57(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate57.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
const _errs1 = errors;
if(!(validate40(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate40.errors : vErrors.concat(validate40.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
valid0 = valid0 || _valid0;
if(_valid0){
var props0 = true;
}
const _errs2 = errors;
if(!(validate43(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate57.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate57.evaluated = {"dynamicProps":true,"dynamicItems":false};
